<template lang="pug">
  v-menu(
    v-model="menu"
    transition="slide-y-reverse-transition"
    bottom offset-y
    max-width="600"
    width="600"
    content-class="px-2 elevation-0"
    :close-on-content-click="false"
  )
    template(v-slot:activator="{ on }")
      v-badge(
        color="error"
        offset-x="18"
        offset-y="18"
        dot overlap bordered
        :value="!wasRead"
      )
        v-btn(
          v-on="on"
          :color="$vuetify.theme.dark ? 'info' : 'secondary'"
          icon
        )
          v-icon mdi-bell-outline
    notification-badge-items(
      :notifications="notifications"
      :loading="loading"
      @update="loadNotifications"
      @read="readNotifications"
      @close="menu = false"
    )
</template>

<script>
import { mapGetters } from 'vuex';
import { Centrifuge } from 'centrifuge';

import NotificationBadgeItems from '@/components/Layout/NotifcationBadgeItems.vue';

export default {
  name: 'NotificationBadge',
  components: {
    NotificationBadgeItems,
  },
  data() {
    return {
      menu: false,
      notifications: [],
      wasRead: true,
      loading: true,
    };
  },
  computed: {
    ...mapGetters({
      userData: 'auth/userData',
    }),
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      this.loadNotifications(0);
      this.setCentrifuge();
    },
    setCentrifuge() {
      const { url, token, channel } = this.$user.data.centrifuge;
      // const CENTRIFUGE_URL = 'ws://localhost:8888/connection/websocket';
      this.centrifuge = new Centrifuge(url, { token });
      const sub = this.centrifuge.newSubscription(channel);
      sub.on('publication', (ctx) => { this.addNotification(ctx.data.export || ctx.data.export); console.log(ctx); });
      sub.subscribe();
      // this.centrifuge.connect();

      this.centrifuge.connect();
      // this.centrifuge.subscribe(`notification#${this.userData.id}`, (m) => {
      //   this.addNotification(m.data.data);
      // });
    },
    addNotification(notification) {
      this.notifications.push({
        created_at: this.$dp.dateprintServer(new Date()),
        ...notification,
      });
      this.$toasted.success(notification.message);
      this.wasRead = false;
    },
    readNotifications(ids) {
      this.notifications = this.notifications.filter((i) => !ids.includes(i.id));
    },
    loadNotifications(type) {
      this.loading = true;
      return this.$rHandler(
        this.$api.notifications.index({
          params: {
            'search[read]': type,
          },
        }),
        ({ data }) => {
          this.notifications = data.data.map((i) => ({
            id: i.id,
            ...i.data,
            created_at: i.created_at,
            wasRead: !!i.read_at,
          }));
          if (!type && this.notifications.length) this.wasRead = false;
          this.loading = false;
          return data;
        },
      );
    },
    // loadNotifications() {
    //   return this.$rHandler(
    //     this.$api.telegram.notifications(this.userData.id),
    //     ({ data }) => {
    //       this.notifications = data.data;
    //       if (this.notifications.length) this.wasRead = false;
    //       return data;
    //     },
    //   );
    // },
  },
};
</script>
